import React from 'react';

import jet, { usePromise } from "@randajan/jet-react";
import { Link, LinkMail } from "@randajan/jet-react/dom/link";
import { Img } from "@randajan/jet-react/dom/img";

import "./Contact.scss";
import lang from '../../../config/lang';
import { GoogleMap } from '../../../elements/GoogleMap/GoogleMap';
import { Article } from '../../../elements/Article/Article';

import { screen } from '../../../config/base';
import { bifrost } from '../../../config/bifrost';

const Office = (props)=>{
  const { address, street, house, city } = props;

  return (
    <>
      <Img src="/icons/pin.svg" alt={lang.office}/>
      <Link to={"https://google.com/maps/search/" + encodeURI(address)}>{city} {street} {house}</Link>
    </>
  )
}

export const Contact = props=>{
  const hqId = props.kin_loc_bill;
  const { result:locs, status } = usePromise([], async _=>{
    const locs = await bifrost.tx("sunListOffices");
    return !Array.isArray(locs) ? [] : locs.sort((a, b)=>a.id === hqId ? 1 : -1);
  }, []);

  const [ screen960w ] = screen.use("960w");
  const showMap = screen960w.get();

  return (
    <div className="Contact" data-status={status}>
        {showMap ? <GoogleMap loc={locs[0]?.address}/> : null }
        <div className="info">
          <h2>{lang.pageContact}</h2>
          <div className="identity">
            <h3 className="realname">{props.name}</h3>
            <div>
              <span>{lang.in}</span>
              <Link to={"https://ares.gov.cz/ekonomicke-subjekty?ico=" + encodeURI(props.in)}>{props.in}</Link>
            </div>
            <div>
              <span>{lang.tin}</span>
              <span>{props.tin}</span>
            </div>
          </div>
          <div className="offices">
            {locs.map((loc, key)=><Office key={key} {...loc}/>)}
          </div>
          <Article src="web-socials"/>
        </div>
    </div>
  );
}